// extracted by mini-css-extract-plugin
export default {"item":"board-row_item__qu6tu"};